import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../components/DashboardLayout';
// import DemoDeviceTableView from './DemoDeviceTableView';
import { DevicesContext } from '../../contexts/DevicesContext';
import '../../styles/pages/device-welcome.css';
import { ChevronsRight } from 'lucide-react';

const DeviceWelcomePage: React.FC<{ showDeviceTable: () => void }> = ({ showDeviceTable }) => {
  const navigate = useNavigate();
  const devicesContext = useContext(DevicesContext);
  if (!devicesContext) {
    throw new Error('useDevices must be used within a DevicesProvider');
  }
  const { demoDevice } = devicesContext;

  const handleAddDevice = () => {
    navigate('/add-device');
  };

  return (
    <DashboardLayout>
      <div className="dashboard-welcome-container">
        <div className='dashboard-welcome-wrapper zoomOutLevel'>
          {/* Header */}
          <div className="welcome-header">
            <h1 className="device-title">Device Manager</h1>
            <p className="device-subtitle ml-0">Manage and monitor your devices.</p>
          </div>

          {/* Welcome Section */}
          <div className="welcome-section">
            {/* Confetti Illustration */}
            <img src={`${process.env.PUBLIC_URL}/DashboardWelcome/Welcome.svg`} alt="confetti" className="confetti-illustration" />

            <h2 className="device-heading">Welcome to SmartEco</h2>
            <p className="device-description">
            Connect your first SmartEco device and unlock real-time air quality insights, trends, and alerts for your space.
            </p>

            <button
              onClick={handleAddDevice}
              className="device-button"
            >
              + Add Your First Device
            </button>
          </div>

          {/* Feature Cards */}
          <div className="feature-cards">
            {/* Card 1 - Connect and Control */}
            <div className="feature-card">
              <div className="feature-icon feature-wifi">
                <img src={`${process.env.PUBLIC_URL}/DashboardWelcome/Wifi.svg`} alt="Connect" />
              </div>
              <p className="feature-text">
              Connect and manage all your SmartEco devices in one unified dashboard.
              </p>
            </div>

            {/* Card 2 - Monitor Performance */}
            <div className="feature-card">
              <div className="feature-icon feature-chart h-full">
                <img src={`${process.env.PUBLIC_URL}/DashboardWelcome/Chart.svg`} alt="Energy" />
              </div>
              <p className="feature-text">
                Monitor device performance and get real-time alerts.
              </p>
            </div>

            {/* Card 3 - Optimize Energy */}
            <div className="feature-card">
              <div className="feature-icon feature-energy">
                <img src={`${process.env.PUBLIC_URL}/DashboardWelcome/Spark.svg`} alt="Energy" />
              </div>
              <p className="feature-text">
                Optimize energy usage and reduce your carbon footprint.
              </p>
            </div>
          </div>

          {/* Demo device for detailed information */}
          {demoDevice && (
            <div className='demo-section'>
              <p>For detailed information, you can refer to the</p>
              <button
                type='button'
                className='demo-section-device'
                onClick={showDeviceTable}
                aria-label='View Demo Device'
              >
                <h4>Demo Device</h4>
                <ChevronsRight size={32} strokeWidth={1.5} />
              </button>
            </div>
          )}

          {/* Demo Device Table */}
          {/* {demoDevice && (
            <DemoDeviceTableView
              devices={[demoDevice]}
              parameters={parametersForDashboard}
            />
          )} */}

        </div>
      </div>
    </DashboardLayout>
  );
};

export default DeviceWelcomePage;
